const RESUME_KEY = 'messaging:resume';

export function returnToMessagingModal(path: string, conversationId: number | null) {
  try {
    sessionStorage.setItem(RESUME_KEY, JSON.stringify({ id: conversationId, time: Date.now() }));
  } catch {
    // Navigation still works when browser storage is unavailable.
  }
  window.location.assign(path);
}

export function consumeMessagingResume(): number | null | undefined {
  try {
    const raw = sessionStorage.getItem(RESUME_KEY);
    if (!raw) return undefined;
    sessionStorage.removeItem(RESUME_KEY);
    const { id, time } = JSON.parse(raw) as { id: number | null; time: number };
    if (!Number.isSafeInteger(time) || Date.now() - time > 60000 || time > Date.now())
      return undefined;
    return Number.isSafeInteger(id) && Number(id) > 0 ? Number(id) : null;
  } catch {
    return undefined;
  }
}
